import { Link } from 'gatsby-plugin-react-i18next'
import { Button } from './Button'

export const ButtonLink = Button.withComponent(Link)
